//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthenticationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Generate 10-minutes life token for an authorization bluetooth device.
    Workflow is described here:
    https://prismacode.visualstudio.com/prismacloud/_wiki/wikis/prismacloud.wiki/688/Bluetooth-device-workflow-in-prismaCLOUD
     */
    getDeviceToken(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/device/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceToken(_response);
        });
    }

    protected processGetDeviceToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Temporary method to simulate signing token by the device.
    ToDo: Remove this method as soon as it's implemented in the device itself.
     * @param signDto Dto with Device serial number and token to be signed (in base-64).
     * @return SignTokenResponseDto containing signature and certificate.
     */
    sign(signDto: SignTokenDto , cancelToken?: CancelToken | undefined): Promise<SignTokenResponseDto> {
        let url_ = this.baseUrl + "/api/device/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSign(_response);
        });
    }

    protected processSign(response: AxiosResponse): Promise<SignTokenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignTokenResponseDto.fromJS(resultData200);
            return Promise.resolve<SignTokenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignTokenResponseDto>(null as any);
    }
}

export class ClientAutoGenerationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Action which is needed so that OnlyForGeneratingApiDto is generated on the client
     */
    onlyForGeneratingApi(dto: OnlyForGeneratingApiDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/dev/ClientAutoGeneration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnlyForGeneratingApi(_response);
        });
    }

    protected processOnlyForGeneratingApi(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DashboardClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Returns the overall report.
     * @deprecated
     */
    overallReport(  cancelToken?: CancelToken | undefined): Promise<OverallReportDto> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverallReport(_response);
        });
    }

    protected processOverallReport(response: AxiosResponse): Promise<OverallReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OverallReportDto.fromJS(resultData200);
            return Promise.resolve<OverallReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OverallReportDto>(null as any);
    }

    /**
     * Returns the weekly report
     * @param dateInWeek (optional) Date in the week for which the report should be returned
     * @param useSundayAsWeekStart (optional) true if you want to get the week from Sunday to Saturday;
    false if you want to get the week starting from exactly the date you provided.
    True by default for backwards compatibility.
     */
    weeklyReport(dateInWeek: string | null | undefined, useSundayAsWeekStart: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<WeekInfoBoxDto> {
        let url_ = this.baseUrl + "/api/Dashboard/week?";
        if (dateInWeek !== undefined && dateInWeek !== null)
            url_ += "dateInWeek=" + encodeURIComponent("" + dateInWeek) + "&";
        if (useSundayAsWeekStart === null)
            throw new Error("The parameter 'useSundayAsWeekStart' cannot be null.");
        else if (useSundayAsWeekStart !== undefined)
            url_ += "useSundayAsWeekStart=" + encodeURIComponent("" + useSundayAsWeekStart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWeeklyReport(_response);
        });
    }

    protected processWeeklyReport(response: AxiosResponse): Promise<WeekInfoBoxDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WeekInfoBoxDto.fromJS(resultData200);
            return Promise.resolve<WeekInfoBoxDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeekInfoBoxDto>(null as any);
    }

    /**
     * Setup user's weekly goal.
    Goal value for corresponding week,
    Start date for the goal to be created or updated
    -------------------------------------------
    THIS METHOD IS OBSOLETE, USE ANOTHER METHOD BELOW
    THIS IS ONLY USED BY APPS before 1.3 (including)
    REMOVE IT ONCE ALL APPS ARE OUT OF THE MARKET
    -------------------------------------------
     * @param goal (optional) New goal value in minutes
     * @deprecated
     */
    setWeeklyGoal(goal: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dashboard/goal?";
        if (goal !== undefined && goal !== null)
            url_ += "goal=" + encodeURIComponent("" + goal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWeeklyGoal(_response);
        });
    }

    protected processSetWeeklyGoal(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Setup user's weekly goal.
    Goal value for corresponding week,
    Start date for the goal to be created or updated
     * @param goalDto Request dto
     */
    setWeeklyGoal2(goalDto: SetGoalDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dashboard/goal/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(goalDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWeeklyGoal2(_response);
        });
    }

    protected processSetWeeklyGoal2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DataUploadClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Uploads SD2Cloud container file and starts it's processing
     * @param lastDate (optional) Date until which including itself you want all days to be filled with empty data
     * @param sd2CloudContainerFile (optional) 
     */
    uploadData(lastDate: string | null | undefined, sd2CloudContainerFile: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DataUpload?";
        if (lastDate !== undefined && lastDate !== null)
            url_ += "lastDate=" + encodeURIComponent("" + lastDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sd2CloudContainerFile !== null && sd2CloudContainerFile !== undefined)
            content_.append("sd2CloudContainerFile", sd2CloudContainerFile.data, sd2CloudContainerFile.fileName ? sd2CloudContainerFile.fileName : "sd2CloudContainerFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadData(_response);
        });
    }

    protected processUploadData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Returns all devices that users ever owned.
    Returned devices are ordered from newest to oldest (i.e. the Current device is always the first in the list).
     */
    getDevices(  cancelToken?: CancelToken | undefined): Promise<DeviceDto[]> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: AxiosResponse): Promise<DeviceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto[]>(null as any);
    }

    /**
     * Adds device to user and make it a current device.
    Requires SN and Code to make sure the user really owns a device.
    See also Authenticate because it has similar logic.
     */
    addDeviceViaCodeAuthentication(request: AuthenticateDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/add-device-via-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDeviceViaCodeAuthentication(_response);
        });
    }

    protected processAddDeviceViaCodeAuthentication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds device to user and make it a current device.
    Requires a bluetooth certificate and signed token to make sure the user really owns a device.
    See also ValidateDeviceAuthenticationRequest because it has similar logic.
     */
    addDeviceViaBluetooth(request: DeviceAuthenticationDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/add-device-via-bluetooth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDeviceViaBluetooth(_response);
        });
    }

    protected processAddDeviceViaBluetooth(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DiaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Creates and saves patient's diary for the current user and last therapy day within given date.
     * @param dto Request dto.
     */
    saveDiary(dto: DiaryRequestDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Diary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDiary(_response);
        });
    }

    protected processSaveDiary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates patient's diary for the current user.
     * @param id Id of the updated diary.
     * @param dto Request update dto
     */
    updateDiary(id: number, dto: DiaryUpdateRequestDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Diary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDiary(_response);
        });
    }

    protected processUpdateDiary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Removes patient's diary for the current user.
     * @param id Id of the removed diary.
     */
    resetDiary(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Diary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetDiary(_response);
        });
    }

    protected processResetDiary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FilesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Downloads small files
     * @param fileId (optional) Id of the file to be downloaded
     */
    download(fileId: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Files?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LoggerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Logs info about device time adjustment.
     * @param info Info about device time adjustment.
     */
    logDeviceTimeAdjusted(info: DeviceTimeAdjustedLogDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(info);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogDeviceTimeAdjusted(_response);
        });
    }

    protected processLogDeviceTimeAdjusted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganisationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Get Organisation information for prismaAPP users
     * @param tenant (optional) Tenant
     */
    getForPatient(tenant: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<OrganisationForPatientsDto> {
        let url_ = this.baseUrl + "/api/Organisation/patient?";
        if (tenant !== undefined && tenant !== null)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForPatient(_response);
        });
    }

    protected processGetForPatient(response: AxiosResponse): Promise<OrganisationForPatientsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganisationForPatientsDto.fromJS(resultData200);
            return Promise.resolve<OrganisationForPatientsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationForPatientsDto>(null as any);
    }
}

export class ProfileClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Removes the user from PatientApp and Identity databases.
     */
    deleteUser(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets device information for current authorized user.
    Obsolete: use GetDevices instead
     * @deprecated
     */
    getDeviceInfo(  cancelToken?: CancelToken | undefined): Promise<DeviceDto> {
        let url_ = this.baseUrl + "/api/Profile/deviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceInfo(_response);
        });
    }

    protected processGetDeviceInfo(response: AxiosResponse): Promise<DeviceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceDto.fromJS(resultData200);
            return Promise.resolve<DeviceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto>(null as any);
    }

    /**
     * Gets user info (preferences)
     */
    getUserInfo(  cancelToken?: CancelToken | undefined): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/api/Profile/userInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfoDto.fromJS(resultData200);
            return Promise.resolve<UserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }

    /**
     * Updates whether user allows to share his therapy data uploaded via Bluetooth with Organisation that owns the device
     */
    setIsSharingDataEnabled(isEnabled: boolean , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Profile/sharingData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isEnabled);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsSharingDataEnabled(_response);
        });
    }

    protected processSetIsSharingDataEnabled(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets device information for current authorized user.
     * @param dto a dto containing mobile token, system language and platform.
     */
    handlePushToken(dto: NotificationTokenDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Profile/pushToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandlePushToken(_response);
        });
    }

    protected processHandlePushToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Clears notification token (e.g. when user logs out).
    This method is anonymous just like token revocation endpoint in IdentityServer
     * @param token notification token which must be deleted
     */
    removeMobileBindAfterLogout(token: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Profile/pushToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMobileBindAfterLogout(_response);
        });
    }

    protected processRemoveMobileBindAfterLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Confirms a user account without providing a password.
    Proxies request to svc_Auth and marks the user as Confirmed if call to svc_Auth succeeds
     * @param dto a dto containing userID and activation code.
     */
    confirmWithoutPassword(dto: ConfirmAccountWithoutPasswordDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/confirm/nopassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmWithoutPassword(_response);
        });
    }

    protected processConfirmWithoutPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Creates PDF report for the current user according to the passed dates
     * @param startDate (optional) Start date of report generation range.
     * @param endDate (optional) End date of report generation range.
     */
    createReportAsFile(startDate: string | undefined, endDate: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/file?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReportAsFile(_response);
        });
    }

    protected processCreateReportAsFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Creates PDF report for the current user according to the passed dates
     * @param createReportDto Report generation DTO (date range and device).
     * @deprecated
     */
    createReport(createReportDto: CreateReportDto , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createReportDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReport(_response);
        });
    }

    protected processCreateReport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TestsApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Called from tests to reset branding info
     * @param tenant (optional) Tenant for which branding info is gonna be deleted
     */
    deleteOrganisation(tenant: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tests/organisation?";
        if (tenant !== undefined && tenant !== null)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganisation(_response);
        });
    }

    protected processDeleteOrganisation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VersionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";

    }

    /**
     * Gets the version of the service.
     * @return A string representing the version.
     */
    version(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the version of the service, requires authentication.
    Used to periodically ping backend from mobile to refresh token when needed.
     * @return A string representing the version.
     */
    versionAuthenticated(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ping-authenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersionAuthenticated(_response);
        });
    }

    protected processVersionAuthenticated(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

/** A machine-readable format for specifying errors in HTTP API responses based on https://tools.ietf.org/html/rfc7807. */
export class ProblemDetails implements IProblemDetails {
    /** A URI reference [RFC3986] that identifies the problem type. This specification encourages that, when
dereferenced, it provide human-readable documentation for the problem type
(e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be
"about:blank". */
    type!: string | null;
    /** A short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
of the problem, except for purposes of localization(e.g., using proactive content negotiation;
see[RFC7231], Section 3.4). */
    title!: string | null;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status!: number | null;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail!: string | null;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance!: string | null;
    /** Gets the IDictionary`2 for extension members.

Problem type definitions MAY extend the problem details object with additional members. Extension members appear in the same namespace as
other members of a problem type. */
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key] !== undefined ? _data["extensions"][key] : <any>null;
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data;
    }
}

/** A machine-readable format for specifying errors in HTTP API responses based on https://tools.ietf.org/html/rfc7807. */
export interface IProblemDetails {
    /** A URI reference [RFC3986] that identifies the problem type. This specification encourages that, when
dereferenced, it provide human-readable documentation for the problem type
(e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be
"about:blank". */
    type: string | null;
    /** A short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
of the problem, except for purposes of localization(e.g., using proactive content negotiation;
see[RFC7231], Section 3.4). */
    title: string | null;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status: number | null;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail: string | null;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance: string | null;
    /** Gets the IDictionary`2 for extension members.

Problem type definitions MAY extend the problem details object with additional members. Extension members appear in the same namespace as
other members of a problem type. */
    extensions: { [key: string]: any; };

    [key: string]: any;
}

/** A ProblemDetails for validation errors. */
export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    /** Gets the validation errors associated with this instance of HttpValidationProblemDetails. */
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

/** A ProblemDetails for validation errors. */
export interface IHttpValidationProblemDetails extends IProblemDetails {
    /** Gets the validation errors associated with this instance of HttpValidationProblemDetails. */
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

/** A ProblemDetails for validation errors. */
export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    /** Gets the validation errors associated with this instance of HttpValidationProblemDetails. */
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

/** A ProblemDetails for validation errors. */
export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    /** Gets the validation errors associated with this instance of HttpValidationProblemDetails. */
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

/** Represents response DTO for simulation of token signing by the device. */
export class SignTokenResponseDto implements ISignTokenResponseDto {
    /** Signed SHA256 hash of Token (Base64-encoded). */
    signature!: string;
    /** Certificate of a device. Contains Serial Number and Root Authority (Base64-encoded). */
    deviceCertificate!: string;

    constructor(data?: ISignTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signature = _data["signature"] !== undefined ? _data["signature"] : <any>null;
            this.deviceCertificate = _data["deviceCertificate"] !== undefined ? _data["deviceCertificate"] : <any>null;
        }
    }

    static fromJS(data: any): SignTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signature"] = this.signature !== undefined ? this.signature : <any>null;
        data["deviceCertificate"] = this.deviceCertificate !== undefined ? this.deviceCertificate : <any>null;
        return data;
    }
}

/** Represents response DTO for simulation of token signing by the device. */
export interface ISignTokenResponseDto {
    /** Signed SHA256 hash of Token (Base64-encoded). */
    signature: string;
    /** Certificate of a device. Contains Serial Number and Root Authority (Base64-encoded). */
    deviceCertificate: string;
}

/** Represents request DTO for simulation of token signing by the device. */
export class SignTokenDto implements ISignTokenDto {
    /** Device serial number. */
    serialNumber!: string;
    /** Generated for a device 10-minutes lifetime token (Base64-encoded). */
    token!: string;

    constructor(data?: ISignTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static fromJS(data: any): SignTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        return data;
    }
}

/** Represents request DTO for simulation of token signing by the device. */
export interface ISignTokenDto {
    /** Device serial number. */
    serialNumber: string;
    /** Generated for a device 10-minutes lifetime token (Base64-encoded). */
    token: string;
}

/** Fake dto is used to provide some data interfaces to the client. */
export abstract class OnlyForGeneratingApiDto implements IOnlyForGeneratingApiDto {
    action!: NotificationDataAction | null;

    constructor(data?: IOnlyForGeneratingApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
        }
    }

    static fromJS(data: any): OnlyForGeneratingApiDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OnlyForGeneratingApiDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : <any>null;
        return data;
    }
}

/** Fake dto is used to provide some data interfaces to the client. */
export interface IOnlyForGeneratingApiDto {
    action: NotificationDataAction | null;
}

/** Enum for push-notification data. Field 'action'. This enum is about how do we handle notification in the app. */
export enum NotificationDataAction {
    None = 0,
    RefreshCurrentWeekData = 1,
}

/** Overall Report */
export class OverallReportDto implements IOverallReportDto {
    /** Minimal date we have data for.
User would be able to scroll back up to this date */
    minDate!: string;
    /** Serial number of the device */
    serialNumber!: string;

    constructor(data?: IOverallReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minDate = _data["minDate"] !== undefined ? _data["minDate"] : <any>null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OverallReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverallReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minDate"] = this.minDate !== undefined ? this.minDate : <any>null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
        return data;
    }
}

/** Overall Report */
export interface IOverallReportDto {
    /** Minimal date we have data for.
User would be able to scroll back up to this date */
    minDate: string;
    /** Serial number of the device */
    serialNumber: string;
}

/** Week info box */
export class WeekInfoBoxDto implements IWeekInfoBoxDto {
    /** Days in the week */
    days!: DayInfoBoxDto[];
    /** Start date of the week */
    startDate!: string;
    /** End date of the week */
    endDate!: string;
    /** Total sleep duration */
    totalSleepTimeInMinutes!: number;
    /** false for the current week; true for all the past weeks */
    isWeekFinished!: boolean;
    /** Analysis of the week data */
    weekAnalysis!: WeekAnalysis | null;
    /** Defined weekly goal in minutes by user.
if user has not defined by him/her - self - will be default value
or calculated by adviser. */
    weeklyGoalValueInMinutes!: number;
    /** Describes how user used a device one week before */
    previousAvgUsageValueInMinutes!: number;
    goal!: WeeklyGoalDto | null;

    constructor(data?: IWeekInfoBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.days = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(DayInfoBoxDto.fromJS(item));
            }
            else {
                this.days = <any>null;
            }
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            this.totalSleepTimeInMinutes = _data["totalSleepTimeInMinutes"] !== undefined ? _data["totalSleepTimeInMinutes"] : <any>null;
            this.isWeekFinished = _data["isWeekFinished"] !== undefined ? _data["isWeekFinished"] : <any>null;
            this.weekAnalysis = _data["weekAnalysis"] ? WeekAnalysis.fromJS(_data["weekAnalysis"]) : <any>null;
            this.weeklyGoalValueInMinutes = _data["weeklyGoalValueInMinutes"] !== undefined ? _data["weeklyGoalValueInMinutes"] : <any>null;
            this.previousAvgUsageValueInMinutes = _data["previousAvgUsageValueInMinutes"] !== undefined ? _data["previousAvgUsageValueInMinutes"] : <any>null;
            this.goal = _data["goal"] ? WeeklyGoalDto.fromJS(_data["goal"]) : <any>null;
        }
    }

    static fromJS(data: any): WeekInfoBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeekInfoBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["totalSleepTimeInMinutes"] = this.totalSleepTimeInMinutes !== undefined ? this.totalSleepTimeInMinutes : <any>null;
        data["isWeekFinished"] = this.isWeekFinished !== undefined ? this.isWeekFinished : <any>null;
        data["weekAnalysis"] = this.weekAnalysis ? this.weekAnalysis.toJSON() : <any>null;
        data["weeklyGoalValueInMinutes"] = this.weeklyGoalValueInMinutes !== undefined ? this.weeklyGoalValueInMinutes : <any>null;
        data["previousAvgUsageValueInMinutes"] = this.previousAvgUsageValueInMinutes !== undefined ? this.previousAvgUsageValueInMinutes : <any>null;
        data["goal"] = this.goal ? this.goal.toJSON() : <any>null;
        return data;
    }
}

/** Week info box */
export interface IWeekInfoBoxDto {
    /** Days in the week */
    days: DayInfoBoxDto[];
    /** Start date of the week */
    startDate: string;
    /** End date of the week */
    endDate: string;
    /** Total sleep duration */
    totalSleepTimeInMinutes: number;
    /** false for the current week; true for all the past weeks */
    isWeekFinished: boolean;
    /** Analysis of the week data */
    weekAnalysis: WeekAnalysis | null;
    /** Defined weekly goal in minutes by user.
if user has not defined by him/her - self - will be default value
or calculated by adviser. */
    weeklyGoalValueInMinutes: number;
    /** Describes how user used a device one week before */
    previousAvgUsageValueInMinutes: number;
    goal: WeeklyGoalDto | null;
}

/** Day of the information box. */
export class DayInfoBoxDto implements IDayInfoBoxDto {
    /** Id of a DeviceBinding this TherapyDay belongs to
Null if we have no data for this day (e.g. day in the future) */
    deviceBindingId!: string;
    /** Therapy Date */
    date!: string;
    /** Is the date in the future */
    isFutureDate!: boolean;
    /** Is data received */
    isDataReceived!: boolean;
    /** Is device usage */
    isDeviceUsage!: boolean;
    /** True if by the current time we expect the data to be in the system already (i.e. after 6PM next day)
Only before 1st day of usage and after last day of usage
These days should be shown as dashed on graph */
    isDataExpectedToAlreadyArrive!: boolean;
    /** Quality value */
    quality!: Score;
    /** e.g. "Superstar", "You reached the daily goal!", "You are slightly under your daily goal" */
    description!: string;
    /** Sleep duration */
    sleepTimeInMinutes!: number;
    /** Sleep duration with humidifier */
    sleepWithHumidifierInMinutes!: number | null;
    /** Deep sleep duration */
    deepSleepInMinutes!: number | null;
    /** Deep sleep quality value */
    deepSleepQuality!: Score;
    /** AHI */
    ahi!: number | null;
    /** AHI quality value */
    ahiQuality!: Score;
    /** Mask fit */
    maskFitPercentage!: number | null;
    /** Leakage value */
    leakage!: number | null;
    /** Leakage quality value */
    leakageQuality!: Score;
    /** List of achievements */
    achievements!: Achievement[] | null;
    /** Patient's diary for the current day.
Describe evaluation of night sleep by patient. */
    diary!: DiaryDto | null;
    /** Value of the goal which was active on a therapy day */
    goalValueInMinutes!: number | null;
    /** Shows whether therapy duration was greater or less than goal value */
    isGoalReached!: boolean;

    constructor(data?: IDayInfoBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceBindingId = _data["deviceBindingId"] !== undefined ? _data["deviceBindingId"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.isFutureDate = _data["isFutureDate"] !== undefined ? _data["isFutureDate"] : <any>null;
            this.isDataReceived = _data["isDataReceived"] !== undefined ? _data["isDataReceived"] : <any>null;
            this.isDeviceUsage = _data["isDeviceUsage"] !== undefined ? _data["isDeviceUsage"] : <any>null;
            this.isDataExpectedToAlreadyArrive = _data["isDataExpectedToAlreadyArrive"] !== undefined ? _data["isDataExpectedToAlreadyArrive"] : <any>null;
            this.quality = _data["quality"] !== undefined ? _data["quality"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.sleepTimeInMinutes = _data["sleepTimeInMinutes"] !== undefined ? _data["sleepTimeInMinutes"] : <any>null;
            this.sleepWithHumidifierInMinutes = _data["sleepWithHumidifierInMinutes"] !== undefined ? _data["sleepWithHumidifierInMinutes"] : <any>null;
            this.deepSleepInMinutes = _data["deepSleepInMinutes"] !== undefined ? _data["deepSleepInMinutes"] : <any>null;
            this.deepSleepQuality = _data["deepSleepQuality"] !== undefined ? _data["deepSleepQuality"] : <any>null;
            this.ahi = _data["ahi"] !== undefined ? _data["ahi"] : <any>null;
            this.ahiQuality = _data["ahiQuality"] !== undefined ? _data["ahiQuality"] : <any>null;
            this.maskFitPercentage = _data["maskFitPercentage"] !== undefined ? _data["maskFitPercentage"] : <any>null;
            this.leakage = _data["leakage"] !== undefined ? _data["leakage"] : <any>null;
            this.leakageQuality = _data["leakageQuality"] !== undefined ? _data["leakageQuality"] : <any>null;
            if (Array.isArray(_data["achievements"])) {
                this.achievements = [] as any;
                for (let item of _data["achievements"])
                    this.achievements!.push(item);
            }
            else {
                this.achievements = <any>null;
            }
            this.diary = _data["diary"] ? DiaryDto.fromJS(_data["diary"]) : <any>null;
            this.goalValueInMinutes = _data["goalValueInMinutes"] !== undefined ? _data["goalValueInMinutes"] : <any>null;
            this.isGoalReached = _data["isGoalReached"] !== undefined ? _data["isGoalReached"] : <any>null;
        }
    }

    static fromJS(data: any): DayInfoBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new DayInfoBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceBindingId"] = this.deviceBindingId !== undefined ? this.deviceBindingId : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["isFutureDate"] = this.isFutureDate !== undefined ? this.isFutureDate : <any>null;
        data["isDataReceived"] = this.isDataReceived !== undefined ? this.isDataReceived : <any>null;
        data["isDeviceUsage"] = this.isDeviceUsage !== undefined ? this.isDeviceUsage : <any>null;
        data["isDataExpectedToAlreadyArrive"] = this.isDataExpectedToAlreadyArrive !== undefined ? this.isDataExpectedToAlreadyArrive : <any>null;
        data["quality"] = this.quality !== undefined ? this.quality : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["sleepTimeInMinutes"] = this.sleepTimeInMinutes !== undefined ? this.sleepTimeInMinutes : <any>null;
        data["sleepWithHumidifierInMinutes"] = this.sleepWithHumidifierInMinutes !== undefined ? this.sleepWithHumidifierInMinutes : <any>null;
        data["deepSleepInMinutes"] = this.deepSleepInMinutes !== undefined ? this.deepSleepInMinutes : <any>null;
        data["deepSleepQuality"] = this.deepSleepQuality !== undefined ? this.deepSleepQuality : <any>null;
        data["ahi"] = this.ahi !== undefined ? this.ahi : <any>null;
        data["ahiQuality"] = this.ahiQuality !== undefined ? this.ahiQuality : <any>null;
        data["maskFitPercentage"] = this.maskFitPercentage !== undefined ? this.maskFitPercentage : <any>null;
        data["leakage"] = this.leakage !== undefined ? this.leakage : <any>null;
        data["leakageQuality"] = this.leakageQuality !== undefined ? this.leakageQuality : <any>null;
        if (Array.isArray(this.achievements)) {
            data["achievements"] = [];
            for (let item of this.achievements)
                data["achievements"].push(item);
        }
        data["diary"] = this.diary ? this.diary.toJSON() : <any>null;
        data["goalValueInMinutes"] = this.goalValueInMinutes !== undefined ? this.goalValueInMinutes : <any>null;
        data["isGoalReached"] = this.isGoalReached !== undefined ? this.isGoalReached : <any>null;
        return data;
    }
}

/** Day of the information box. */
export interface IDayInfoBoxDto {
    /** Id of a DeviceBinding this TherapyDay belongs to
Null if we have no data for this day (e.g. day in the future) */
    deviceBindingId: string;
    /** Therapy Date */
    date: string;
    /** Is the date in the future */
    isFutureDate: boolean;
    /** Is data received */
    isDataReceived: boolean;
    /** Is device usage */
    isDeviceUsage: boolean;
    /** True if by the current time we expect the data to be in the system already (i.e. after 6PM next day)
Only before 1st day of usage and after last day of usage
These days should be shown as dashed on graph */
    isDataExpectedToAlreadyArrive: boolean;
    /** Quality value */
    quality: Score;
    /** e.g. "Superstar", "You reached the daily goal!", "You are slightly under your daily goal" */
    description: string;
    /** Sleep duration */
    sleepTimeInMinutes: number;
    /** Sleep duration with humidifier */
    sleepWithHumidifierInMinutes: number | null;
    /** Deep sleep duration */
    deepSleepInMinutes: number | null;
    /** Deep sleep quality value */
    deepSleepQuality: Score;
    /** AHI */
    ahi: number | null;
    /** AHI quality value */
    ahiQuality: Score;
    /** Mask fit */
    maskFitPercentage: number | null;
    /** Leakage value */
    leakage: number | null;
    /** Leakage quality value */
    leakageQuality: Score;
    /** List of achievements */
    achievements: Achievement[] | null;
    /** Patient's diary for the current day.
Describe evaluation of night sleep by patient. */
    diary: DiaryDto | null;
    /** Value of the goal which was active on a therapy day */
    goalValueInMinutes: number | null;
    /** Shows whether therapy duration was greater or less than goal value */
    isGoalReached: boolean;
}

/** Score */
export enum Score {
    Great = 0,
    Good = 1,
    Average = 2,
    Bad = 3,
    Absent = 4,
}

/** Achievement */
export enum Achievement {
    DeepSleep = 1,
    EffectiveTherapy = 2,
    MaskFit = 3,
    GoodAhi = 4,
}

/** Represents patient's diary for a day. */
export class DiaryDto implements IDiaryDto {
    /** Unique identificator of Diary. */
    id!: number;
    /** Evaluation of sleep by patient. */
    rate!: number;
    /** Patient's notes about night. How it was. */
    note!: string;
    /** Date of therapy for which patient fill the diary. */
    therapyDate!: string;
    /** Describe it is possible to edit diary record ot not. */
    isAvailableToEdit!: boolean;

    constructor(data?: IDiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.therapyDate = _data["therapyDate"] !== undefined ? _data["therapyDate"] : <any>null;
            this.isAvailableToEdit = _data["isAvailableToEdit"] !== undefined ? _data["isAvailableToEdit"] : <any>null;
        }
    }

    static fromJS(data: any): DiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["therapyDate"] = this.therapyDate !== undefined ? this.therapyDate : <any>null;
        data["isAvailableToEdit"] = this.isAvailableToEdit !== undefined ? this.isAvailableToEdit : <any>null;
        return data;
    }
}

/** Represents patient's diary for a day. */
export interface IDiaryDto {
    /** Unique identificator of Diary. */
    id: number;
    /** Evaluation of sleep by patient. */
    rate: number;
    /** Patient's notes about night. How it was. */
    note: string;
    /** Date of therapy for which patient fill the diary. */
    therapyDate: string;
    /** Describe it is possible to edit diary record ot not. */
    isAvailableToEdit: boolean;
}

/** Analysis of the week data */
export class WeekAnalysis implements IWeekAnalysis {
    /** Compliance level in Stars */
    complianceLevel!: Stars;
    /** AHI level in Stars */
    ahiLevel!: Stars;
    /** Leakage level in Stars */
    leakageLevel!: Stars;
    /** Deep Sleep level in Stars */
    deepSleepLevel!: Stars;
    /** Average Deep Sleep duration during the week */
    averageDeepSleepInMinutes!: number | null;
    /** Indicates that device was not used some days during current week. */
    isNotFullWeek!: boolean;

    constructor(data?: IWeekAnalysis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.complianceLevel = _data["complianceLevel"] !== undefined ? _data["complianceLevel"] : <any>null;
            this.ahiLevel = _data["ahiLevel"] !== undefined ? _data["ahiLevel"] : <any>null;
            this.leakageLevel = _data["leakageLevel"] !== undefined ? _data["leakageLevel"] : <any>null;
            this.deepSleepLevel = _data["deepSleepLevel"] !== undefined ? _data["deepSleepLevel"] : <any>null;
            this.averageDeepSleepInMinutes = _data["averageDeepSleepInMinutes"] !== undefined ? _data["averageDeepSleepInMinutes"] : <any>null;
            this.isNotFullWeek = _data["isNotFullWeek"] !== undefined ? _data["isNotFullWeek"] : <any>null;
        }
    }

    static fromJS(data: any): WeekAnalysis {
        data = typeof data === 'object' ? data : {};
        let result = new WeekAnalysis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["complianceLevel"] = this.complianceLevel !== undefined ? this.complianceLevel : <any>null;
        data["ahiLevel"] = this.ahiLevel !== undefined ? this.ahiLevel : <any>null;
        data["leakageLevel"] = this.leakageLevel !== undefined ? this.leakageLevel : <any>null;
        data["deepSleepLevel"] = this.deepSleepLevel !== undefined ? this.deepSleepLevel : <any>null;
        data["averageDeepSleepInMinutes"] = this.averageDeepSleepInMinutes !== undefined ? this.averageDeepSleepInMinutes : <any>null;
        data["isNotFullWeek"] = this.isNotFullWeek !== undefined ? this.isNotFullWeek : <any>null;
        return data;
    }
}

/** Analysis of the week data */
export interface IWeekAnalysis {
    /** Compliance level in Stars */
    complianceLevel: Stars;
    /** AHI level in Stars */
    ahiLevel: Stars;
    /** Leakage level in Stars */
    leakageLevel: Stars;
    /** Deep Sleep level in Stars */
    deepSleepLevel: Stars;
    /** Average Deep Sleep duration during the week */
    averageDeepSleepInMinutes: number | null;
    /** Indicates that device was not used some days during current week. */
    isNotFullWeek: boolean;
}

/** Stars */
export enum Stars {
    NoStars = 0,
    OneStar = 1,
    TwoStars = 2,
    ThreeStars = 3,
    FourStars = 4,
    FiveStars = 5,
}

/** Goal info container for week info box */
export class WeeklyGoalDto implements IWeeklyGoalDto {
    /** Defined weekly goal in minutes by user.
if user has not defined by him/her - self - will be default value
or calculated by adviser. */
    weeklyGoalValueInMinutes!: number;
    /** Defined start date of the goal */
    goalStartDate!: string;

    constructor(data?: IWeeklyGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weeklyGoalValueInMinutes = _data["weeklyGoalValueInMinutes"] !== undefined ? _data["weeklyGoalValueInMinutes"] : <any>null;
            this.goalStartDate = _data["goalStartDate"] !== undefined ? _data["goalStartDate"] : <any>null;
        }
    }

    static fromJS(data: any): WeeklyGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weeklyGoalValueInMinutes"] = this.weeklyGoalValueInMinutes !== undefined ? this.weeklyGoalValueInMinutes : <any>null;
        data["goalStartDate"] = this.goalStartDate !== undefined ? this.goalStartDate : <any>null;
        return data;
    }
}

/** Goal info container for week info box */
export interface IWeeklyGoalDto {
    /** Defined weekly goal in minutes by user.
if user has not defined by him/her - self - will be default value
or calculated by adviser. */
    weeklyGoalValueInMinutes: number;
    /** Defined start date of the goal */
    goalStartDate: string;
}

/** Goal info container for set goal */
export class SetGoalDto implements ISetGoalDto {
    /** Defined goal in minutes by user.
if user has not defined by him/her - self - will be default value
or calculated by adviser. */
    goalValueInMinutes!: number;
    /** Defined start date of the goal */
    goalStartDate!: string;

    constructor(data?: ISetGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.goalValueInMinutes = _data["goalValueInMinutes"] !== undefined ? _data["goalValueInMinutes"] : <any>null;
            this.goalStartDate = _data["goalStartDate"] !== undefined ? _data["goalStartDate"] : <any>null;
        }
    }

    static fromJS(data: any): SetGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["goalValueInMinutes"] = this.goalValueInMinutes !== undefined ? this.goalValueInMinutes : <any>null;
        data["goalStartDate"] = this.goalStartDate !== undefined ? this.goalStartDate : <any>null;
        return data;
    }
}

/** Goal info container for set goal */
export interface ISetGoalDto {
    /** Defined goal in minutes by user.
if user has not defined by him/her - self - will be default value
or calculated by adviser. */
    goalValueInMinutes: number;
    /** Defined start date of the goal */
    goalStartDate: string;
}

/** Represents short device information. */
export class DeviceDto implements IDeviceDto {
    /** Id of a device binding */
    deviceBindingId!: string;
    /** Device Generation. */
    deviceGeneration!: DeviceGeneration;
    /** Device serial number. */
    serialNumber!: string;
    /** Last known device firmware version. */
    firmwareVersion!: string;
    /** Last known date when device send data to PrismaCloud. */
    lastSyncDate!: string;
    /** String row describes device brand. e.g. prismaSmart, prismaSoft etc. */
    deviceBrand!: string;
    /** Device type code, based on generation (known as just "device type" to the firmware team).
Null in case of p28 device - when data was not given via RabbitMQ yet.
Or at the feature initialization (August of 2020). */
    deviceTypeCode!: number | null;
    /** Extended wireless device type. Null in case if the device is not p2.8 wireless device. */
    wirelessDeviceType!: ExtendedWirelessDeviceType | null;
    /** TherapyDate when user switched to this device. */
    startDate!: string;
    /** Last TherapyDate that this device was used. */
    endDate!: string;
    /** Last time when therapy data was uploaded from device */
    lastDataUploadDate!: string | null;
    /** Device tenant */
    tenant!: string;
    /** End date of ownership.
The device will be disabled from receiving modem data from this date (a therapy date that is the same as this date or later). */
    ownershipLostDate!: string;

    constructor(data?: IDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceBindingId = _data["deviceBindingId"] !== undefined ? _data["deviceBindingId"] : <any>null;
            this.deviceGeneration = _data["deviceGeneration"] !== undefined ? _data["deviceGeneration"] : <any>null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : <any>null;
            this.firmwareVersion = _data["firmwareVersion"] !== undefined ? _data["firmwareVersion"] : <any>null;
            this.lastSyncDate = _data["lastSyncDate"] !== undefined ? _data["lastSyncDate"] : <any>null;
            this.deviceBrand = _data["deviceBrand"] !== undefined ? _data["deviceBrand"] : <any>null;
            this.deviceTypeCode = _data["deviceTypeCode"] !== undefined ? _data["deviceTypeCode"] : <any>null;
            this.wirelessDeviceType = _data["wirelessDeviceType"] !== undefined ? _data["wirelessDeviceType"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            this.lastDataUploadDate = _data["lastDataUploadDate"] !== undefined ? _data["lastDataUploadDate"] : <any>null;
            this.tenant = _data["tenant"] !== undefined ? _data["tenant"] : <any>null;
            this.ownershipLostDate = _data["ownershipLostDate"] !== undefined ? _data["ownershipLostDate"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceBindingId"] = this.deviceBindingId !== undefined ? this.deviceBindingId : <any>null;
        data["deviceGeneration"] = this.deviceGeneration !== undefined ? this.deviceGeneration : <any>null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
        data["firmwareVersion"] = this.firmwareVersion !== undefined ? this.firmwareVersion : <any>null;
        data["lastSyncDate"] = this.lastSyncDate !== undefined ? this.lastSyncDate : <any>null;
        data["deviceBrand"] = this.deviceBrand !== undefined ? this.deviceBrand : <any>null;
        data["deviceTypeCode"] = this.deviceTypeCode !== undefined ? this.deviceTypeCode : <any>null;
        data["wirelessDeviceType"] = this.wirelessDeviceType !== undefined ? this.wirelessDeviceType : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["lastDataUploadDate"] = this.lastDataUploadDate !== undefined ? this.lastDataUploadDate : <any>null;
        data["tenant"] = this.tenant !== undefined ? this.tenant : <any>null;
        data["ownershipLostDate"] = this.ownershipLostDate !== undefined ? this.ownershipLostDate : <any>null;
        return data;
    }
}

/** Represents short device information. */
export interface IDeviceDto {
    /** Id of a device binding */
    deviceBindingId: string;
    /** Device Generation. */
    deviceGeneration: DeviceGeneration;
    /** Device serial number. */
    serialNumber: string;
    /** Last known device firmware version. */
    firmwareVersion: string;
    /** Last known date when device send data to PrismaCloud. */
    lastSyncDate: string;
    /** String row describes device brand. e.g. prismaSmart, prismaSoft etc. */
    deviceBrand: string;
    /** Device type code, based on generation (known as just "device type" to the firmware team).
Null in case of p28 device - when data was not given via RabbitMQ yet.
Or at the feature initialization (August of 2020). */
    deviceTypeCode: number | null;
    /** Extended wireless device type. Null in case if the device is not p2.8 wireless device. */
    wirelessDeviceType: ExtendedWirelessDeviceType | null;
    /** TherapyDate when user switched to this device. */
    startDate: string;
    /** Last TherapyDate that this device was used. */
    endDate: string;
    /** Last time when therapy data was uploaded from device */
    lastDataUploadDate: string | null;
    /** Device tenant */
    tenant: string;
    /** End date of ownership.
The device will be disabled from receiving modem data from this date (a therapy date that is the same as this date or later). */
    ownershipLostDate: string;
}

/** Device Platform */
export enum DeviceGeneration {
    Undefined = 0,
    SomnoBalance = 1,
    P3 = 2,
    P2_8 = 3,
    P3_4 = 4,
    P5 = 5,
}

/** Prisma SOFT and Prisma SMART specific wireless state. */
export enum ExtendedWirelessDeviceType {
    Standard = 0,
    Plus = 2,
    Max = 3,
}

/** Authenticate */
export class AuthenticateDto implements IAuthenticateDto {
    /** SerialNumber of the device. */
    deviceSerialNumber!: string;
    /** Daily security code of the device */
    dailyDeviceSecurityCode!: number;

    constructor(data?: IAuthenticateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceSerialNumber = _data["deviceSerialNumber"] !== undefined ? _data["deviceSerialNumber"] : <any>null;
            this.dailyDeviceSecurityCode = _data["dailyDeviceSecurityCode"] !== undefined ? _data["dailyDeviceSecurityCode"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceSerialNumber"] = this.deviceSerialNumber !== undefined ? this.deviceSerialNumber : <any>null;
        data["dailyDeviceSecurityCode"] = this.dailyDeviceSecurityCode !== undefined ? this.dailyDeviceSecurityCode : <any>null;
        return data;
    }
}

/** Authenticate */
export interface IAuthenticateDto {
    /** SerialNumber of the device. */
    deviceSerialNumber: string;
    /** Daily security code of the device */
    dailyDeviceSecurityCode: number;
}

export class BluetoothDeviceIdentificationInfo implements IBluetoothDeviceIdentificationInfo {
    /** Extended wireless device type for P2_8
devices.
In case of non-wireless devices - null. */
    extendedWirelessDeviceType!: ExtendedWirelessDeviceType | null;
    /** Device type code as it is stored in device (known as just "device type" to the firmware team). */
    deviceTypeCode!: number;

    constructor(data?: IBluetoothDeviceIdentificationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extendedWirelessDeviceType = _data["extendedWirelessDeviceType"] !== undefined ? _data["extendedWirelessDeviceType"] : <any>null;
            this.deviceTypeCode = _data["deviceTypeCode"] !== undefined ? _data["deviceTypeCode"] : <any>null;
        }
    }

    static fromJS(data: any): BluetoothDeviceIdentificationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BluetoothDeviceIdentificationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extendedWirelessDeviceType"] = this.extendedWirelessDeviceType !== undefined ? this.extendedWirelessDeviceType : <any>null;
        data["deviceTypeCode"] = this.deviceTypeCode !== undefined ? this.deviceTypeCode : <any>null;
        return data;
    }
}

export interface IBluetoothDeviceIdentificationInfo {
    /** Extended wireless device type for P2_8
devices.
In case of non-wireless devices - null. */
    extendedWirelessDeviceType: ExtendedWirelessDeviceType | null;
    /** Device type code as it is stored in device (known as just "device type" to the firmware team). */
    deviceTypeCode: number;
}

/** Represents request DTO for a authorization/validation bluetooth device. */
export class DeviceAuthenticationDto extends BluetoothDeviceIdentificationInfo implements IDeviceAuthenticationDto {
    /** Serial number that is used only in logging (to debug potential issues with certificate).
After validating the certificate we use SerialNumber from certificate only.
Without this field we have no easy way to search the logs for issues with device authentication. */
    serialNumberForLogging!: string;
    /** Generated for a device 10-minutes lifetime token. ASCII only. */
    token!: string;
    /** Signed SHA256 hash of Token (Base64-encoded). */
    signature!: string;
    /** Certificate of a device. Contains Serial Number and Root Authority (Base64-encoded). */
    deviceCertificate!: string;
    /** If false, device validation will throw exception if there's an upgraded account linked to the device.
If true, new Bluetooth DeviceBinding is created even if upgraded account exists.
The following workflow is assumed:
1. Mobile app first sends DeviceAuthentication request with IgnoreExistingAccount = false
2. If exception about upgraded account is received, the error is shown to the user.
User is able to stop the pairing and log in to that account instead.
3. If user chooses to proceed, DeviceAuthentication is called again with IgnoreExistingAccount = true.
New DeviceBinding is created in this case. */
    ignoreExistingAccount!: boolean;

    constructor(data?: IDeviceAuthenticationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serialNumberForLogging = _data["serialNumberForLogging"] !== undefined ? _data["serialNumberForLogging"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.signature = _data["signature"] !== undefined ? _data["signature"] : <any>null;
            this.deviceCertificate = _data["deviceCertificate"] !== undefined ? _data["deviceCertificate"] : <any>null;
            this.ignoreExistingAccount = _data["ignoreExistingAccount"] !== undefined ? _data["ignoreExistingAccount"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceAuthenticationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAuthenticationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumberForLogging"] = this.serialNumberForLogging !== undefined ? this.serialNumberForLogging : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["signature"] = this.signature !== undefined ? this.signature : <any>null;
        data["deviceCertificate"] = this.deviceCertificate !== undefined ? this.deviceCertificate : <any>null;
        data["ignoreExistingAccount"] = this.ignoreExistingAccount !== undefined ? this.ignoreExistingAccount : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Represents request DTO for a authorization/validation bluetooth device. */
export interface IDeviceAuthenticationDto extends IBluetoothDeviceIdentificationInfo {
    /** Serial number that is used only in logging (to debug potential issues with certificate).
After validating the certificate we use SerialNumber from certificate only.
Without this field we have no easy way to search the logs for issues with device authentication. */
    serialNumberForLogging: string;
    /** Generated for a device 10-minutes lifetime token. ASCII only. */
    token: string;
    /** Signed SHA256 hash of Token (Base64-encoded). */
    signature: string;
    /** Certificate of a device. Contains Serial Number and Root Authority (Base64-encoded). */
    deviceCertificate: string;
    /** If false, device validation will throw exception if there's an upgraded account linked to the device.
If true, new Bluetooth DeviceBinding is created even if upgraded account exists.
The following workflow is assumed:
1. Mobile app first sends DeviceAuthentication request with IgnoreExistingAccount = false
2. If exception about upgraded account is received, the error is shown to the user.
User is able to stop the pairing and log in to that account instead.
3. If user chooses to proceed, DeviceAuthentication is called again with IgnoreExistingAccount = true.
New DeviceBinding is created in this case. */
    ignoreExistingAccount: boolean;
}

/** Represents request DTO for creation and edit patient's diary. */
export class DiaryRequestDto implements IDiaryRequestDto {
    /** Evaluation of sleep by patient.
From 1 to 5, where 1 is bad and 5 is very well. */
    rate!: number;
    /** Some comments about night. */
    note!: string;
    /** Date for which create/edit is going. */
    diaryDate!: string;

    constructor(data?: IDiaryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.diaryDate = _data["diaryDate"] !== undefined ? _data["diaryDate"] : <any>null;
        }
    }

    static fromJS(data: any): DiaryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["diaryDate"] = this.diaryDate !== undefined ? this.diaryDate : <any>null;
        return data;
    }
}

/** Represents request DTO for creation and edit patient's diary. */
export interface IDiaryRequestDto {
    /** Evaluation of sleep by patient.
From 1 to 5, where 1 is bad and 5 is very well. */
    rate: number;
    /** Some comments about night. */
    note: string;
    /** Date for which create/edit is going. */
    diaryDate: string;
}

/** Represents request DTO for updating and edit patient's diary. */
export class DiaryUpdateRequestDto implements IDiaryUpdateRequestDto {
    /** Evaluation of sleep by patient.
From 1 to 5, where 1 is bad and 5 is very well. */
    rate!: number;
    /** Some comments about night. */
    note!: string;

    constructor(data?: IDiaryUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): DiaryUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

/** Represents request DTO for updating and edit patient's diary. */
export interface IDiaryUpdateRequestDto {
    /** Evaluation of sleep by patient.
From 1 to 5, where 1 is bad and 5 is very well. */
    rate: number;
    /** Some comments about night. */
    note: string;
}

/** Dto represents information about device time adjustment procedure. */
export class DeviceTimeAdjustedLogDto implements IDeviceTimeAdjustedLogDto {
    /** Serial number of the device. */
    serialNumber!: string;
    /** Firmware version of the device. */
    firmwareVersion!: string;
    /** Device time UTC as string, because it might be in some unknown formats. */
    deviceUTC!: string;
    /** Device offset in seconds. */
    deviceOffset!: string;
    /** Whether device time correction was successful. */
    isCorrectionSuccessful!: boolean;
    /** Error message if something went wrong with synchronization. */
    errorMessage!: string;

    constructor(data?: IDeviceTimeAdjustedLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : <any>null;
            this.firmwareVersion = _data["firmwareVersion"] !== undefined ? _data["firmwareVersion"] : <any>null;
            this.deviceUTC = _data["deviceUTC"] !== undefined ? _data["deviceUTC"] : <any>null;
            this.deviceOffset = _data["deviceOffset"] !== undefined ? _data["deviceOffset"] : <any>null;
            this.isCorrectionSuccessful = _data["isCorrectionSuccessful"] !== undefined ? _data["isCorrectionSuccessful"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceTimeAdjustedLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTimeAdjustedLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
        data["firmwareVersion"] = this.firmwareVersion !== undefined ? this.firmwareVersion : <any>null;
        data["deviceUTC"] = this.deviceUTC !== undefined ? this.deviceUTC : <any>null;
        data["deviceOffset"] = this.deviceOffset !== undefined ? this.deviceOffset : <any>null;
        data["isCorrectionSuccessful"] = this.isCorrectionSuccessful !== undefined ? this.isCorrectionSuccessful : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data;
    }
}

/** Dto represents information about device time adjustment procedure. */
export interface IDeviceTimeAdjustedLogDto {
    /** Serial number of the device. */
    serialNumber: string;
    /** Firmware version of the device. */
    firmwareVersion: string;
    /** Device time UTC as string, because it might be in some unknown formats. */
    deviceUTC: string;
    /** Device offset in seconds. */
    deviceOffset: string;
    /** Whether device time correction was successful. */
    isCorrectionSuccessful: boolean;
    /** Error message if something went wrong with synchronization. */
    errorMessage: string;
}

/** Organisation data transferred to patients */
export class OrganisationForPatientsDto implements IOrganisationForPatientsDto {
    /** Legal name of the Organisation */
    name!: string;
    /** Binary string for image file of the light logo */
    lightThemeLogoId!: number | null;
    /** Binary string for image file of the dark logo */
    darkThemeLogoId!: number | null;
    /** Slogan of the Organisation */
    slogan!: string;
    /** Address of the Organisation */
    address!: string;
    /** Telephone number for patients to contact Organisation
It is stored as it was entered by Organisation, because masks in different countries differ */
    telephone!: string;
    /** Fax number for patients to contact Organisation
It is stored as it was entered by Organisation, because masks in different countries differ */
    fax!: string;
    /** Email for patients to contact Organisation */
    email!: string;
    /** First link entered by Organisation */
    firstLink!: string;
    /** First link's name entered by Organisation */
    firstLinkName!: string;
    /** Second link entered by Organisation */
    secondLink!: string;
    /** Second link's name entered by Organisation */
    secondLinkName!: string;

    constructor(data?: IOrganisationForPatientsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.lightThemeLogoId = _data["lightThemeLogoId"] !== undefined ? _data["lightThemeLogoId"] : <any>null;
            this.darkThemeLogoId = _data["darkThemeLogoId"] !== undefined ? _data["darkThemeLogoId"] : <any>null;
            this.slogan = _data["slogan"] !== undefined ? _data["slogan"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.firstLink = _data["firstLink"] !== undefined ? _data["firstLink"] : <any>null;
            this.firstLinkName = _data["firstLinkName"] !== undefined ? _data["firstLinkName"] : <any>null;
            this.secondLink = _data["secondLink"] !== undefined ? _data["secondLink"] : <any>null;
            this.secondLinkName = _data["secondLinkName"] !== undefined ? _data["secondLinkName"] : <any>null;
        }
    }

    static fromJS(data: any): OrganisationForPatientsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationForPatientsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["lightThemeLogoId"] = this.lightThemeLogoId !== undefined ? this.lightThemeLogoId : <any>null;
        data["darkThemeLogoId"] = this.darkThemeLogoId !== undefined ? this.darkThemeLogoId : <any>null;
        data["slogan"] = this.slogan !== undefined ? this.slogan : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["telephone"] = this.telephone !== undefined ? this.telephone : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["firstLink"] = this.firstLink !== undefined ? this.firstLink : <any>null;
        data["firstLinkName"] = this.firstLinkName !== undefined ? this.firstLinkName : <any>null;
        data["secondLink"] = this.secondLink !== undefined ? this.secondLink : <any>null;
        data["secondLinkName"] = this.secondLinkName !== undefined ? this.secondLinkName : <any>null;
        return data;
    }
}

/** Organisation data transferred to patients */
export interface IOrganisationForPatientsDto {
    /** Legal name of the Organisation */
    name: string;
    /** Binary string for image file of the light logo */
    lightThemeLogoId: number | null;
    /** Binary string for image file of the dark logo */
    darkThemeLogoId: number | null;
    /** Slogan of the Organisation */
    slogan: string;
    /** Address of the Organisation */
    address: string;
    /** Telephone number for patients to contact Organisation
It is stored as it was entered by Organisation, because masks in different countries differ */
    telephone: string;
    /** Fax number for patients to contact Organisation
It is stored as it was entered by Organisation, because masks in different countries differ */
    fax: string;
    /** Email for patients to contact Organisation */
    email: string;
    /** First link entered by Organisation */
    firstLink: string;
    /** First link's name entered by Organisation */
    firstLinkName: string;
    /** Second link entered by Organisation */
    secondLink: string;
    /** Second link's name entered by Organisation */
    secondLinkName: string;
}

/** User settings */
export class UserInfoDto implements IUserInfoDto {
    /** Data sharing is Enabled flag */
    isSharingEnabled!: boolean | null;
    /** Current user's streak */
    currentStreak!: StreakDto | null;
    /** The largest streak of user */
    maxStreak!: StreakDto | null;
    /** Minimal date that we have for this user */
    minDate!: string | null;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSharingEnabled = _data["isSharingEnabled"] !== undefined ? _data["isSharingEnabled"] : <any>null;
            this.currentStreak = _data["currentStreak"] ? StreakDto.fromJS(_data["currentStreak"]) : <any>null;
            this.maxStreak = _data["maxStreak"] ? StreakDto.fromJS(_data["maxStreak"]) : <any>null;
            this.minDate = _data["minDate"] !== undefined ? _data["minDate"] : <any>null;
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSharingEnabled"] = this.isSharingEnabled !== undefined ? this.isSharingEnabled : <any>null;
        data["currentStreak"] = this.currentStreak ? this.currentStreak.toJSON() : <any>null;
        data["maxStreak"] = this.maxStreak ? this.maxStreak.toJSON() : <any>null;
        data["minDate"] = this.minDate !== undefined ? this.minDate : <any>null;
        return data;
    }
}

/** User settings */
export interface IUserInfoDto {
    /** Data sharing is Enabled flag */
    isSharingEnabled: boolean | null;
    /** Current user's streak */
    currentStreak: StreakDto | null;
    /** The largest streak of user */
    maxStreak: StreakDto | null;
    /** Minimal date that we have for this user */
    minDate: string | null;
}

/** Dto bearing info about user's streaks */
export class StreakDto implements IStreakDto {
    /** Goal value which was achieved */
    startOfStreak!: string | null;
    /** Number of days when goal was achieved */
    days!: number;

    constructor(data?: IStreakDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startOfStreak = _data["startOfStreak"] !== undefined ? _data["startOfStreak"] : <any>null;
            this.days = _data["days"] !== undefined ? _data["days"] : <any>null;
        }
    }

    static fromJS(data: any): StreakDto {
        data = typeof data === 'object' ? data : {};
        let result = new StreakDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startOfStreak"] = this.startOfStreak !== undefined ? this.startOfStreak : <any>null;
        data["days"] = this.days !== undefined ? this.days : <any>null;
        return data;
    }
}

/** Dto bearing info about user's streaks */
export interface IStreakDto {
    /** Goal value which was achieved */
    startOfStreak: string | null;
    /** Number of days when goal was achieved */
    days: number;
}

/** Dto for token and platform gathering. */
export class NotificationTokenDto implements INotificationTokenDto {
    /** Mobile notification token. */
    token!: string;
    /** Mobile platform. */
    platform!: MobilePlatform;
    /** User's system language. */
    language!: string;

    constructor(data?: INotificationTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.platform = _data["platform"] !== undefined ? _data["platform"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["platform"] = this.platform !== undefined ? this.platform : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

/** Dto for token and platform gathering. */
export interface INotificationTokenDto {
    /** Mobile notification token. */
    token: string;
    /** Mobile platform. */
    platform: MobilePlatform;
    /** User's system language. */
    language: string;
}

/** Enum for mobile platforms */
export enum MobilePlatform {
    Android = 0,
    IOS = 1,
}

/** A dto to confirm an account after registration implying the password was already set (e.g. in PatientApp) */
export class ConfirmAccountWithoutPasswordDto implements IConfirmAccountWithoutPasswordDto {
    /** The user Subject, for which the verification should be done. */
    userSubject!: string;
    /** The activation code to verify that the user actually received the email. */
    code!: string;

    constructor(data?: IConfirmAccountWithoutPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSubject = _data["userSubject"] !== undefined ? _data["userSubject"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmAccountWithoutPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAccountWithoutPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSubject"] = this.userSubject !== undefined ? this.userSubject : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }
}

/** A dto to confirm an account after registration implying the password was already set (e.g. in PatientApp) */
export interface IConfirmAccountWithoutPasswordDto {
    /** The user Subject, for which the verification should be done. */
    userSubject: string;
    /** The activation code to verify that the user actually received the email. */
    code: string;
}

/** Represents report generation object. */
export class CreateReportDto implements ICreateReportDto {
    /** Start date of report generation range. */
    startDate!: string;
    /** End date of report generation range. */
    endDate!: string;

    constructor(data?: ICreateReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
        }
    }

    static fromJS(data: any): CreateReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        return data;
    }
}

/** Represents report generation object. */
export interface ICreateReportDto {
    /** Start date of report generation range. */
    startDate: string;
    /** End date of report generation range. */
    endDate: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}